import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { PiecesJointesPicker } from './PiecesJointesPicker';

export const EnvoiEmailCandidatDialog = ({ open, onOpenChange, candidat, onEnvoye }) => {
  const [objet, setObjet] = useState('');
  const [corps, setCorps] = useState(`Bonjour ${candidat?.prenom || ''},\n\n\n\nCordialement,\nL'équipe FISL`);
  const [pieces, setPieces] = useState([]);
  const [envoi, setEnvoi] = useState(false);

  const envoyer = async () => {
    setEnvoi(true);
    try {
      const r = await axios.post(`/emails-envoyes/candidat/${candidat.user_id}`, { objet, corps, pieces });
      toast.success(r.data.message);
      setObjet(''); setPieces([]);
      onOpenChange(false);
      onEnvoye?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "L'e-mail n'a pas pu être envoyé");
    } finally { setEnvoi(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="envoi-email-candidat-dialog">
        <DialogHeader>
          <DialogTitle>Envoyer un e-mail</DialogTitle>
          <DialogDescription>Destinataire : {candidat?.prenom} {candidat?.nom} ({candidat?.email})</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label htmlFor="email-cand-objet">Objet</Label>
            <Input id="email-cand-objet" value={objet} onChange={(e) => setObjet(e.target.value)} data-testid="email-candidat-objet" />
          </div>
          <div>
            <Label htmlFor="email-cand-corps">Message</Label>
            <Textarea id="email-cand-corps" rows={9} value={corps} onChange={(e) => setCorps(e.target.value)} data-testid="email-candidat-corps" />
          </div>
          <PiecesJointesPicker candidatId={candidat?.user_id} value={pieces} onChange={setPieces} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={envoyer} disabled={envoi || !objet.trim() || !corps.trim()} className="bg-[#8DC63F] hover:bg-[#7AB62F]" data-testid="email-candidat-envoyer">
            <Send className="h-4 w-4 mr-2" /> {envoi ? 'Envoi en cours…' : 'Envoyer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
